import React from 'react'
import VerifyEmail from '../components/Mail/VerifyEmail'
// import EmailVerify from '../components/emailverification/Emailverify'

const EmailVerifyPage = () => {
  return (
    <div>
       <VerifyEmail/>
    </div>
  )
}

export default EmailVerifyPage